import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Menu, Button } from 'antd'
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  PieChartOutlined,
  ContainerOutlined,
  CarOutlined,
  SafetyCertificateOutlined,
  CompassOutlined,
  FileSearchOutlined,
  DatabaseOutlined,
  SettingOutlined,
  RiseOutlined
  // MoneyCollectOutlined
} from '@ant-design/icons'
// import bqLogo from '../../img/iqram-logo-main-nobg.png'
import WithUser from 'hocs/WithUser'
import WithData from 'hocs/WithData'
import { useTheme } from '../../theme/ThemeContext'

const { SubMenu } = Menu

const DashboardSidebar = props => {
  const { theme } = useTheme()
  const [collapsed, setCollapsed] = useState()

  const toggleCollapsed = () => {
    setCollapsed(!collapsed)
  }

  return (
    <React.Fragment>
      <div
        className="dashboard_sidebar"
        style={{ height: '100vh', overflowY: 'auto' }}
      >
        {/* <img
          src={bqLogo}
          alt="logo"
          className="dashboard_sidebar_logo"
          onClick={() => props.history.push('/')}
          style={{ height: '5rem', width: '5rem' }}
        /> */}

        <Menu
          defaultSelectedKeys={['1']}
          defaultOpenKeys={['']}
          mode="inline"
          theme={theme}
          inlineCollapsed={collapsed}
          className="dashboard_sidebar_menu"
          style={{ height: 'auto' }}
        >
          <Menu.Item
            key="1"
            icon={<PieChartOutlined />}
            onClick={() => props.history.push('/')}
          >
            Overview
          </Menu.Item>

          {/* <SubMenu
            key="sub5"
            icon={<MoneyCollectOutlined />}
            title="Transactions"
          >
            <Menu.Item
              key="10"
              onClick={() => props.history.push('/transactions')}
            >
              View
            </Menu.Item>
          </SubMenu> */}

          {/*
            Four menus became one.

            Cars, Car Orders, Car Tasks and Car Requests were four top-level entries for four
            views of the same thing — a car we have, are getting, are preparing, or have been
            asked to find. With a second service on the dashboard, four of anything at the top
            level is what makes a sidebar unreadable, so they are grouped here instead.

            `Menu.ItemGroup` rather than nested SubMenus: the headings label the grouping without
            adding another click to reach a page somebody opens twenty times a day.
          */}
          <SubMenu key="cars" icon={<CarOutlined />} title="Cars">
            <Menu.ItemGroup key="cars-catalogue" title="Catalogue">
              <Menu.Item key="cars-view" onClick={() => props.history.push('/cars')}>
                All cars
              </Menu.Item>
              <Menu.Item key="cars-add" onClick={() => props.history.push('/cars/add-new')}>
                Add a car
              </Menu.Item>
              <Menu.Item key="cars-tasks" onClick={() => props.history.push('/car-tasks')}>
                Preparation tasks
              </Menu.Item>
            </Menu.ItemGroup>
            {/* The Telegram bot that manages cars: what it changed, who may command it, what it
                costs. The car work itself happens in the chat. */}
            <Menu.ItemGroup key="cars-assistant" title="Inventory assistant">
              <Menu.Item
                key="cars-assistant-changes"
                onClick={() => props.history.push('/inventory-assistant/changes')}
              >
                Change log
              </Menu.Item>
              <Menu.Item
                key="cars-assistant-people"
                onClick={() => props.history.push('/inventory-assistant/people')}
              >
                Who can use it
              </Menu.Item>
              <Menu.Item
                key="cars-assistant-usage"
                onClick={() => props.history.push('/inventory-assistant/usage')}
              >
                AI usage
              </Menu.Item>
            </Menu.ItemGroup>
            <Menu.ItemGroup key="cars-orders" title="Orders &amp; requests">
              <Menu.Item key="cars-orders-view" onClick={() => props.history.push('/car-orders')}>
                Orders
              </Menu.Item>
              <Menu.Item
                key="cars-orders-add"
                onClick={() => props.history.push('/car-orders/add-new')}
              >
                New order
              </Menu.Item>
              {/* A customer asking us to FIND a car. Beside orders because it is about buying
                  one, not about checking duty. */}
              <Menu.Item
                key="cars-requests"
                onClick={() => props.history.push('/car-requests')}
              >
                Customer requests
              </Menu.Item>
            </Menu.ItemGroup>
          </SubMenu>

          {/*
            Everything duty, in one place.

            "Custom Duties" and "Duty Assistant" were two menus for one service — the difference
            was which Django app happened to own the model, which is not a distinction anyone
            using the dashboard can see. The work items come first; the things you set once and
            rarely touch are grouped under Setup.
          */}
          <SubMenu key="duty" icon={<ContainerOutlined />} title="Custom Duties">
            <Menu.ItemGroup key="duty-work" title="Day to day">
              <Menu.Item key="duty-requests" onClick={() => props.history.push('/custom-duties')}>
                Duty requests
              </Menu.Item>
              <Menu.Item
                key="duty-conversations"
                onClick={() => props.history.push('/duty-assistant/conversations')}
              >
                Conversations
              </Menu.Item>
              <Menu.Item
                key="duty-customers"
                onClick={() => props.history.push('/custom-duties/customers')}
              >
                Customers
              </Menu.Item>
              <Menu.Item
                key="duty-payments"
                onClick={() => props.history.push('/duty-assistant/payments')}
              >
                Payments
              </Menu.Item>
            </Menu.ItemGroup>
            <Menu.ItemGroup key="duty-setup" title="Setup">
              <Menu.Item
                key="duty-pricing"
                onClick={() => props.history.push('/duty-assistant/pricing')}
              >
                Pricing
              </Menu.Item>
              <Menu.Item
                key="duty-promotions"
                onClick={() => props.history.push('/duty-assistant/promotions')}
              >
                Promotions
              </Menu.Item>
              <Menu.Item
                key="duty-dealers"
                onClick={() => props.history.push('/duty-assistant/dealers')}
              >
                Dealers
              </Menu.Item>
              <Menu.Item
                key="duty-shipping"
                onClick={() => props.history.push('/custom-duties/shipping-fees')}
              >
                Shipping fees
              </Menu.Item>
              <Menu.Item
                key="duty-msrp"
                onClick={() => props.history.push('/custom-duties/msrp-whitelist')}
              >
                MSRP whitelist
              </Menu.Item>
              <Menu.Item
                key="duty-banking-rates"
                onClick={() => props.history.push('/custom-duties/banking-rates')}
              >
                Banking rates
              </Menu.Item>
              <Menu.Item
                key="car-rates"
                onClick={() => props.history.push('/custom-duties/car-rates')}
              >
                Car rates
              </Menu.Item>
              <Menu.Item
                key="duty-badges"
                onClick={() => props.history.push('/duty-assistant/drive-train-badges')}
              >
                Drive train badges
              </Menu.Item>
            </Menu.ItemGroup>
          </SubMenu>

          {/* The second service. Same three-part shape as duty — work, money, setup — so a
              third service has an obvious place to go. */}
          <SubMenu key="insurance" icon={<SafetyCertificateOutlined />} title="Insurance">
            <Menu.Item
              key="insurance-policies"
              onClick={() => props.history.push('/insurance/policies')}
            >
              Policies
            </Menu.Item>
            <Menu.Item
              key="insurance-settlement"
              onClick={() => props.history.push('/insurance/settlement')}
            >
              Settlement
            </Menu.Item>
            <Menu.Item
              key="insurance-setup"
              onClick={() => props.history.push('/insurance/setup')}
            >
              Rates &amp; setup
            </Menu.Item>
          </SubMenu>

          {/* The fourth service, in the same work-then-setup shape: one page anybody opens every
              day, and three that are read when something is wrong. */}
          <SubMenu key="tracking" icon={<CompassOutlined />} title="Tracking">
            <Menu.ItemGroup key="tracking-work" title="Day to day">
              <Menu.Item
                key="tracking-shipments"
                onClick={() => props.history.push('/tracking/shipments')}
              >
                Shipments
              </Menu.Item>
              {/* A customer is sitting in a WhatsApp chat having been told a person will look at
                  their bill of lading, so this belongs beside the worklist and not in Setup. */}
              <Menu.Item
                key="tracking-bills-of-lading"
                onClick={() => props.history.push('/tracking/bills-of-lading')}
              >
                Bills of lading
              </Menu.Item>
              {/* Tracking's own WhatsApp conversations, not mixed in with duty's. */}
              <Menu.Item
                key="tracking-conversations"
                onClick={() => props.history.push('/tracking/conversations')}
              >
                Conversations
              </Menu.Item>
            </Menu.ItemGroup>
            <Menu.ItemGroup key="tracking-setup" title="Setup">
              <Menu.Item
                key="tracking-lines"
                onClick={() => props.history.push('/tracking/lines')}
              >
                Shipping lines
              </Menu.Item>
              <Menu.Item
                key="tracking-pricing"
                onClick={() => props.history.push('/tracking/pricing')}
              >
                Pricing
              </Menu.Item>
              <Menu.Item
                key="tracking-account"
                onClick={() => props.history.push('/tracking/account')}
              >
                ShipsGo account
              </Menu.Item>
            </Menu.ItemGroup>
          </SubMenu>

          {/* The fifth service. Orders first, in the same work-then-setup shape as tracking:
              the packages are priced once and the orders are read every day. */}
          <SubMenu key="vehicle-history" icon={<FileSearchOutlined />} title="Vehicle history">
            <Menu.ItemGroup key="vehicle-history-work" title="Day to day">
              <Menu.Item
                key="vehicle-history-orders"
                onClick={() => props.history.push('/vehicle-history/orders')}
              >
                Orders
              </Menu.Item>
              <Menu.Item
                key="vehicle-history-conversations"
                onClick={() => props.history.push('/vehicle-history/conversations')}
              >
                Conversations
              </Menu.Item>
            </Menu.ItemGroup>
            <Menu.ItemGroup key="vehicle-history-setup" title="Setup">
              <Menu.Item
                key="vehicle-history-products"
                onClick={() => props.history.push('/vehicle-history/products')}
              >
                Report packages
              </Menu.Item>
              <Menu.Item
                key="vehicle-history-supplier"
                onClick={() => props.history.push('/vehicle-history/supplier')}
              >
                GlobalVIN account
              </Menu.Item>
            </Menu.ItemGroup>
          </SubMenu>

          {/* The owner's growth bot (spec: 0042_growth_bot): events worth attending and a weekly
              look-back at the assistant. Who may use the bot is set on the inventory People page. */}
          <SubMenu key="growth" icon={<RiseOutlined />} title="Growth">
            <Menu.Item key="growth-opportunities" onClick={() => props.history.push('/growth/opportunities')}>
              Opportunities
            </Menu.Item>
            <Menu.Item key="growth-places" onClick={() => props.history.push('/growth/places')}>
              Places in reach
            </Menu.Item>
            <Menu.Item key="growth-reviews" onClick={() => props.history.push('/growth/reviews')}>
              Weekly reviews
            </Menu.Item>
            <Menu.Item key="growth-runs" onClick={() => props.history.push('/growth/runs')}>
              Runs &amp; spend
            </Menu.Item>
            <Menu.Item key="growth-settings" onClick={() => props.history.push('/growth/settings')}>
              Settings
            </Menu.Item>
          </SubMenu>

          <SubMenu key="sub14" icon={<ContainerOutlined />} title="Transactions">
            <Menu.Item
              key="30"
              onClick={() => props.history.push('/transactions')}
            >
              View
            </Menu.Item>
          </SubMenu>

          {/*
            What every service shares. These pages were filed under the service that built them
            first — Assistant settings and the knowledge base under Custom Duties, Payment routes
            under Transactions — which made them hard to find once the assistant sold four things.
          */}
          <SubMenu key="settings" icon={<SettingOutlined />} title="Settings">
            <Menu.ItemGroup key="settings-assistant" title="WhatsApp assistant">
              <Menu.Item
                key="settings-assistant-switches"
                onClick={() => props.history.push('/settings/assistant')}
              >
                Assistant settings
              </Menu.Item>
              <Menu.Item
                key="settings-knowledge-base"
                onClick={() => props.history.push('/settings/knowledge-base')}
              >
                Knowledge base
              </Menu.Item>
              <Menu.Item
                key="settings-follow-ups"
                onClick={() => props.history.push('/settings/follow-ups')}
              >
                Follow-up messages
              </Menu.Item>
              <Menu.Item
                key="settings-broadcasts"
                onClick={() => props.history.push('/settings/broadcasts')}
              >
                Broadcasts
              </Menu.Item>
            </Menu.ItemGroup>
            <Menu.ItemGroup key="settings-payments" title="Payments">
              <Menu.Item
                key="settings-payment-routes"
                onClick={() => props.history.push('/settings/payment-routes')}
              >
                Payment routes
              </Menu.Item>
            </Menu.ItemGroup>
          </SubMenu>

          <SubMenu key="sub4" icon={<DatabaseOutlined />} title="User Management">
            <Menu.Item key="8" onClick={() => props.history.push('/customers')}>
              View
            </Menu.Item>
            <Menu.Item
              key="9"
              onClick={() => props.history.push('/customers/add-new')}
            >
              Add New
            </Menu.Item>
          </SubMenu>

          {/* <SubMenu
            key="sub7"
            icon={<UsergroupAddOutlined />}
            title="Manage Users"
          >
            <Menu.Item key="17" onClick={() => props.history.push('/users')}>
              View Users
            </Menu.Item>
            <Menu.Item
              key="18"
              onClick={() => props.history.push('/users/add-new')}
            >
              Add User
            </Menu.Item>
          </SubMenu> */}

          {/* <Menu.Item
            key="22"
            icon={<SettingOutlined />}
            onClick={() => props.history.push('/users/my-account')}
          >
            Account Settings
          </Menu.Item> */}
        </Menu>

        <Button
          type="primary"
          onClick={toggleCollapsed}
          className="dashboard_sidebar_btn"
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined
          )}
        </Button>
      </div>
    </React.Fragment>
  )
}

DashboardSidebar.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
  authUser: PropTypes.shape({
    user: PropTypes.shape({
      branches: PropTypes.array
    })
  })
}

export default withRouter(WithUser(WithData(DashboardSidebar)))
